import { useScrollAnimation, fadeInUp, fadeInLeft, fadeInRight, AnimatedDiv, AnimatedH2, AnimatedP } from "@/hooks/useScrollAnimation";
import farmImage from "@/assets/farm-pistachio-orchard.jpg";

const AboutSection = () => {
  const { ref, controls } = useScrollAnimation();

  return (
    <section className="py-20 md:py-28 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        <AnimatedDiv
          ref={ref}
          initial="hidden"
          animate={controls}
          variants={fadeInUp}
          className="text-center mb-16"
        >
          <p className="text-sm font-medium text-primary tracking-[0.3em] uppercase mb-4">Who We Are</p>
          <AnimatedH2 variants={fadeInUp} className="text-3xl md:text-5xl heading-luxury text-foreground mb-4">
            About Us
          </AnimatedH2>
          <div className="section-divider mt-4"></div>
        </AnimatedDiv>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center max-w-6xl mx-auto">
          <AnimatedDiv initial="hidden" animate={controls} variants={fadeInLeft}>
            <div className="rounded-xl overflow-hidden shadow-xl">
              <img 
                src={farmImage} 
                alt="Pistachio orchard in California Central Valley" 
                className="w-full h-[400px] lg:h-[500px] object-cover"
                loading="lazy"
                width={1920}
                height={1080}
              />
            </div>
          </AnimatedDiv>

          <AnimatedDiv initial="hidden" animate={controls} variants={fadeInRight} className="space-y-6">
            <h3 className="text-2xl md:text-3xl font-semibold text-foreground leading-tight">
              Your Trusted Agricultural Real Estate Experts
            </h3>
            
            <p className="text-muted-foreground leading-relaxed text-lg">
              We are more than just real estate agents—we are <strong className="text-foreground">farmers with real, hands-on experience</strong> in agriculture. Whether you're buying or selling a farm in California's Central Valley, our expert knowledge, strong network, and industry insight will guide you every step of the way.
            </p>
            
            <p className="text-muted-foreground leading-relaxed text-lg">
              We specialize in agricultural real estate across <strong className="text-foreground">Merced, Madera, and Fresno counties</strong>. Our primary focus is on high-value crops such as <strong className="text-foreground">almonds and pistachios</strong>, where we have extensive experience.
            </p>
            
            <p className="text-muted-foreground leading-relaxed text-lg">
              As multi-generational farmers ourselves, we don't just assist with investments—we actively manage our own farms, bringing firsthand knowledge and practical insights to every deal.
            </p>

            <div className="pt-4 space-y-3">
              <p className="text-primary font-semibold text-xl italic">
                "Let's grow together!"
              </p>
              <p className="text-muted-foreground">
                Explore our services:{" "}
                <a href="/buy-a-farm" className="text-primary underline underline-offset-4">buy a farm</a>,{" "}
                <a href="/sell-a-farm" className="text-primary underline underline-offset-4">sell a farm</a>, or{" "}
                <a href="/farm-management" className="text-primary underline underline-offset-4">farm management</a>. New buyers — start with our{" "}
                <a href="/guides/buying-a-farm-central-valley" className="text-primary underline underline-offset-4">Central Valley farm-buying guide</a>.
              </p>
            </div>
          </AnimatedDiv>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
